import { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import InputField from '../../../inputField';
import { validateField } from '../../../../../utility/validation';
import { useCustomEffect } from '../../../../../utility/hooks';
import { REPLY_FIELD } from './config';

const useStyles = makeStyles(
  ({ palette: { primary }, spacing, breakpoints }) => ({
    main: {
      display: 'flex',
      flexDirection: 'column',
      marginBottom: spacing(4),
      '&:last-of-type': {
        marginBottom: 0,
      },
      [breakpoints.up('sm')]: {
        marginBottom: spacing(6),
      },
    },
    reply: {
      marginBottom: spacing(3),
      [breakpoints.up('sm')]: {
        marginBottom: spacing(6),
      },
    },
    replyError: {
      marginBottom: spacing(1),
    },
    replyInsights: {
      marginBottom: 0,
    },
    replyInput: {
      borderRadius: 8,
      '& textarea': {
        height: 144,
      },
      [breakpoints.up('sm')]: {
        '& textarea': {
          height: 174,
        },
      },
    },
    replyInputText: {
      fontSize: 16,
      lineHeight: '20px',
      '&::placeholder': {
        fontSize: 16,
        lineHeight: '20px',
      },
    },
    enpsDisabledField: {
      pointerEvents: 'none',
      backgroundColor: primary.white,
      borderRadius: 3,
      border: `1px solid ${primary.bluish6}`,
    },
  })
);

const EnpsFreeTextAnswer = ({
  translations,
  questionId,
  subject = {},
  initialAnswer = {},
  error = null,
  isInsightsView = false,
  isDisabled = false,
  onSetError,
  onChange,
}) => {
  const classes = useStyles();

  const [answer, setAnswer] = useState(initialAnswer);

  useCustomEffect(
    () => {
      setAnswer(initialAnswer);
      onChange(questionId, subject, initialAnswer);
      onSetError(null, subject);
    },
    [questionId],
    true
  );

  const handleOnChange = async event => {
    event.persist();
    const { value } = event.target;
    const caretStart = event.target.selectionStart;
    const caretEnd = event.target.selectionEnd;
    const currentError = await validateField(REPLY_FIELD, value);
    const updatedAnswer = {
      reply: value,
      not_applicable: false,
    };

    setAnswer(updatedAnswer);

    onChange(questionId, subject, updatedAnswer);
    onSetError(currentError, subject);
    event.target.setSelectionRange(caretStart, caretEnd);
  };

  return (
    <div className={classes.main}>
      <div
        className={classNames(classes.reply, {
          [classes.replyError]: !!error,
          [classes.replyInsights]: isInsightsView,
        })}
      >
        <InputField
          className={classNames(classes.replyInput, {
            [classes.enpsDisabledField]: isDisabled,
          })}
          customInputClass={classes.replyInputText}
          name={REPLY_FIELD.name}
          placeholder={translations.purposePlaceholder}
          value={answer.reply || ''}
          rows={REPLY_FIELD.rows}
          multiline={REPLY_FIELD.isMultiline}
          error={!!error}
          errorMessage={
            translations[REPLY_FIELD.name].validationMessages?.[error]
          }
          onChange={handleOnChange}
          disabled={isDisabled}
          fullWidth
        />
      </div>
    </div>
  );
};

EnpsFreeTextAnswer.propTypes = {
  translations: PropTypes.shape({}).isRequired,
  subject: PropTypes.shape({}),
  questionId: PropTypes.number.isRequired,
  initialAnswer: PropTypes.shape({}),
  isDisabled: PropTypes.bool,
  error: PropTypes.string,
  isInsightsView: PropTypes.bool,
  onSetError: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default EnpsFreeTextAnswer;
